import { setHeaderData } from '@/store/header_data_slice/header_data_slice';
import { setFooterData } from '@/store/footer_data_slice/footer_data_slice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from '@/utils/api';

const fetchHeaderFooterData = () => {
  const dispatch = useDispatch();
  const headerApiData = useSelector((state) => state.header);
  const footerApiData = useSelector((state) => state.footer);

  // const fetchHeader = async () => {
  //   try {
  //     const response = await fetchData('header');
  //     const data = response.data;
  //     dispatch(setHeaderData(data));
  //   } catch (error) {
  //       console.log("Error", error);
  //   }
  // };

  // const fetchFooter = async () => {
  //   try {
  //     const response = await fetchData('footer');
  //     const data = response.data;
  //     dispatch(setFooterData(data));
  //   } catch (error) {
  //     console.log("Error", error);
  //   }
  // };

  return {
    headerApiData,
    footerApiData
  };
};

export default fetchHeaderFooterData;